import type { CSSProperties } from 'react';

/** @graph-connects none */
export const CHART_COLORS = ['#0017C1', '#3460FB', '#7096F8', '#FE3939', '#C5D7FB'] as const;

/** @graph-connects none */
export const CHART_COLORS_EXTENDED = [
  ...CHART_COLORS,
  '#00B894',
  '#FDCB6E',
  '#E17055',
  '#A855F7',
  '#22C55E',
  '#FF8C42',
] as const;

/**
 * 予実管理の実績の色（目標は CHART_COLORS[0]）。
 * @graph-connects none
 */
export const BUDGET_ACTUAL_COLOR = '#E55B3C';

/**
 * オファーによる上乗せの斜線の地の色。実績の色を 28% の濃さにしたもので、斜線の線は実績の色そのまま。
 * 実績と同系の色にして「実績の一部」と読めるようにする。
 * @graph-connects none
 */
export const OFFER_UPLIFT_TINT = 'rgba(229, 91, 60, 0.28)';

/**
 * オファーによる上乗せの斜線（CSS の背景）。表の割合の横棒に使う。
 * グラフ（SVG）は同じ色・同じ線幅の pattern で描き、見た目をそろえる。
 * @graph-connects none
 */
export const OFFER_UPLIFT_HATCH_BACKGROUND = `repeating-linear-gradient(135deg, ${BUDGET_ACTUAL_COLOR} 0 2px, ${OFFER_UPLIFT_TINT} 2px 5px)`;

/** @graph-connects none */
export const TOOLTIP_CONTENT_STYLE: CSSProperties = {
  background: 'var(--color-bg-elevated, #fff)',
  border: '1px solid var(--color-border)',
  borderRadius: '8px',
  fontSize: '12px',
  color: 'var(--color-text-primary)',
};

/** @graph-connects none */
export const AXIS_TICK_STYLE = {
  fontSize: 10,
  fill: 'var(--color-text-muted)',
} as const;

/** @graph-connects none */
export const GRID_PROPS = {
  stroke: 'var(--color-border)',
  strokeDasharray: '3 3',
} as const;

/** @graph-connects none */
export const LEGEND_PROPS = {
  verticalAlign: 'bottom' as const,
  height: 36,
  wrapperStyle: { fontSize: '10px' },
};

/** @graph-connects none */
export const LEGEND_CLICKABLE_PROPS = {
  ...LEGEND_PROPS,
  wrapperStyle: { fontSize: '10px', cursor: 'pointer' },
};
